import { Spin } from "antd"
import { isEmpty } from "lodash"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { removeDiacritics } from "src/lib/stringsUtils"
import SearchTree from "src/pages/ADMIN/MemberContact/ListAssociation/components/SearchTree"
import {
  setListOrganization,
  setLoading,
} from "src/redux/slices/customerDirectory"
import AccountService from "src/services/AccountService"
import { ListOrganizationStyled } from "./styled"

const formatOrganizationTree = items =>
  items.map(item => ({
    ...item,
    key: item.AccountID,
    title: item.AccountName,
    removeDiacriticsTitle: removeDiacritics(
      item.AccountName?.toLowerCase() || "",
    ),
    isLeaf: !item.HasChild,
    children: item.HasChild ? [] : undefined,
  }))

const flattenTree = nodes => {
  let result = []
  nodes.forEach(node => {
    result.push({
      key: node.key,
      title: node.title,
      removeDiacriticsTitle: node.removeDiacriticsTitle,
    })
    if (node.children && node.children.length > 0) {
      result = result.concat(flattenTree(node.children))
    }
  })
  return result
}

const ListOrganization = ({ organizationSelect, setOrganizationSelect }) => {
  const dispatch = useDispatch()
  const { lstOrganization } = useSelector(state => state.customerDirectory)
  const [loading, setLoadingState] = useState(false)
  const [showUnknownMember, setShowUnknownMember] = useState(false)

  useEffect(() => {
    getListOrganization()
  }, [])

  const getListOrganization = () => {
    setLoadingState(true)
    dispatch(setLoading(true))
    AccountService.getChildAccountByParentID({
      ParentID: "00000000-0000-0000-0000-000000000000",
    })
      .then(res => {
        if (res.isOk) {
          const treeData = formatOrganizationTree(res.Object)
          const dataList = flattenTree(treeData)
          dispatch(setListOrganization({ tree: treeData, dataList }))
        }
      })
      .finally(() => {
        setLoadingState(false)
        dispatch(setLoading(false))
      })
  }

  return (
    <ListOrganizationStyled>
      <Spin spinning={loading}>
        <div
          style={{
            marginBottom: 12,
            padding: "8px 12px",
            background: "#f5f5f5",
            borderRadius: 6,
            fontWeight: 600,
          }}
        >
          Danh sách đơn vị
        </div>

        {!isEmpty(lstOrganization?.tree) && (
          <SearchTree
            treeDataDefault={[
              {
                key: 0,
                title: "Hiệp hội sức khỏe",
                removeDiacriticsTitle: removeDiacritics("hiệp hội sức khỏe"),
                children: lstOrganization.tree,
              },
            ]}
            dataList={[
              {
                key: 0,
                title: "Hiệp hội sức khỏe",
                removeDiacriticsTitle: removeDiacritics("hiệp hội sức khỏe"),
              },
              ...(lstOrganization.dataList || []),
            ]}
            selectedNode={
              organizationSelect || { key: 0, title: "Hiệp hội sức khỏe" }
            }
            setSelectedNote={setOrganizationSelect}
            onSelectUnknown={() => {
              setShowUnknownMember(true)
              setOrganizationSelect({
                key: "UNKNOWN_MEMBER",
                title: "Chưa có đơn vị",
              })
            }}
          />
        )}
      </Spin>
    </ListOrganizationStyled>
  )
}

export default React.memo(ListOrganization)

ListOrganization.propTypes = {
  organizationSelect: PropTypes.object.isRequired,
  setOrganizationSelect: PropTypes.func.isRequired,
}
